import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Breadcrumb from '../../components/breadcrumb/Breadcrumb';
import { Helmet } from 'react-helmet';

const BlogDetail = () => {
    // Using useLocation to get state passed from the previous route
    const location = useLocation();
    const navigate = useNavigate();

    // Extracting state from location
    const { state } = location || {};
    const { title, detail, time, img } = state || {};

    // If no data is passed, handle navigation or show a message
    if (!state) {
        return (
            <div className="container">
                <h2>Blog Post Not Found</h2>
                <p>Sorry, the blog post you are looking for does not exist.</p>
                <button className="btn btn-primary mt-3" onClick={() => navigate(-1)}>
                    Go Back
                </button>
            </div>
        );
    }

    return (
        <>
            <Helmet>
                <title>Blog Detail || Shiv Computers</title>
                
            </Helmet>
            <Breadcrumb title="Blog Detail" />
            <div className="container">
                <div className="row py-4">
                    <div className="col-md-12">
                        <div className="card">
                            <img
                                src={img}
                                className="card-img-top img-fluid"
                                style={{ height: '500px', objectFit: 'cover' }}
                                alt={title || 'Blog Image'}
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
                <div className="row py-4">
                    <div className="col-md-12">
                        <div className="card-body">
                            <h2>{title}</h2>
                            <div className="d-flex justify-content-between">
                                <p><i className="bi bi-clock"></i> <span className="text-muted">{time}</span></p>
                            </div>
                            <p className="text-justify">{detail}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BlogDetail;
